import React from "react";
import { useSelector } from "react-redux";
import CountrySelector from "../CountrySelector";
import { useTranslation } from "../../contexts/LanguageContext";

export default function AuctionStatistics() {
  const { auctions, clips, orders, withdrawls, loading } = useSelector((state) => state.dashboard);
  const { t } = useTranslation();

  const auctionStats = [
    { label: t("dashboard.totalAuctions"), value: auctions.totalAuctions, color: "bg-blue-500" },
    { label: t("dashboard.live"), value: auctions.totalLiveAuctions, color: "bg-green-500" },
    { label: t("dashboard.scheduled"), value: auctions.totalScheduledAuctions, color: "bg-yellow-500" },
    { label: t("dashboard.completed"), value: auctions.totalCompletedAuctions, color: "bg-purple-500" },
    { label: t("dashboard.cancelled"), value: auctions.totalCancelledAuctions, color: "bg-red-500" },
    { label: t("dashboard.draft"), value: auctions.totalDraftAuctions, color: "bg-gray-500" },
  ];

  const otherStats = [
    { label: t("dashboard.totalClips"), value: clips.totalClips },
    { label: t("dashboard.activeClips"), value: clips.totalActiveClips },
    { label: t("dashboard.stats.totalOrders"), value: orders.totalOrders },
    { label: t("dashboard.withdrawals"), value: withdrawls.totalWithdrawls },
  ];

  return (
    <div className="bg-white px-4 py-4 border border-gray-100 shadow-md rounded-lg">
      {/* Header Area */}
      <div className="flex items-center justify-between">
        <h3 className="font-medium font-base">{t("dashboard.auctionStatistics")}</h3>
        <CountrySelector />
      </div>
      <div className="mt-6"></div>

      {loading ? (
        <div className="flex justify-center items-center py-8">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
        </div>
      ) : (
        <div className="space-y-4">
          {/* Auction Stats Grid */}
          <div className="grid grid-cols-2 gap-3">
            {auctionStats.map((stat, index) => (
              <div key={index} className="flex items-center justify-between p-2 bg-gray-50 rounded">
                <span className="text-xs text-gray-600">{stat.label}</span>
                <span className={`text-sm font-semibold ${stat.color.replace('bg-', 'text-')}`}>
                  {stat.value}
                </span>
              </div>
            ))}
          </div>

          {/* Divider */}
          <div className="border-t border-gray-200 my-3"></div>

          {/* Other Stats */}
          <div className="grid grid-cols-2 gap-3">
            {otherStats.map((stat, index) => (
              <div key={index} className="flex items-center justify-between p-2 bg-gray-50 rounded">
                <span className="text-xs text-gray-600">{stat.label}</span>
                <span className="text-sm font-semibold text-themeGray">{stat.value}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
